export default __webpack_public_path__ + "static/media/promo_03.1c18de2c.jpg";